/* Castor Hub UK - mini cart drawer (31-10-2026). Opens after any add to basket (listens for ch:cart-updated
   from ch-collection.js / ch-product.js). Not on /cart. Buy it now skips the drawer. No delivery/returns text here. */
(function () {
  if (window.chMiniCart) return;
  var onCart = /^\/cart\/?$/.test(location.pathname);
  var css = '' +
    '.chm-scrim{position:fixed;inset:0;background:rgba(15,26,36,.5);z-index:2147483000;opacity:0;visibility:hidden;transition:opacity .2s,visibility .2s}' +
    '.chm{position:fixed;top:0;right:0;bottom:0;width:min(420px,100vw);background:#fff;z-index:2147483001;display:flex;flex-direction:column;transform:translateX(102%);transition:transform .25s ease;font-family:var(--ch-body,Inter,system-ui,sans-serif);color:var(--ch-ink,#0F1A24);box-shadow:-12px 0 32px rgba(15,26,36,.18)}' +
    '.chm-open .chm{transform:none}.chm-open .chm-scrim{opacity:1;visibility:visible}' +
    'html.chm-lock,html.chm-lock body{overflow:hidden}' +
    '.chm *{box-sizing:border-box}' +
    '.chm-h{display:flex;align-items:center;justify-content:space-between;padding:16px 18px;border-bottom:1px solid var(--ch-line,#D8DCD9)}' +
    '.chm-h b{font-family:var(--ch-head,Archivo,sans-serif);font-size:19px;font-weight:800}' +
    '.chm-x{border:0;background:none;font-size:30px;line-height:1;cursor:pointer;color:var(--ch-ink,#0F1A24);padding:0 4px}' +
    '.chm-ok{display:flex;align-items:center;gap:8px;margin:12px 18px 0;padding:10px 12px;border-radius:8px;background:#E9F5EE;color:#1E6B42;font-weight:600;font-size:14px}' +
    '.chm-ok[hidden]{display:none}' +
    '.chm-list{flex:1;overflow-y:auto;overscroll-behavior:contain;padding:4px 18px;margin:0;list-style:none}' +
    '.chm-i{display:grid;grid-template-columns:76px minmax(0,1fr);gap:12px;padding:14px 0;border-bottom:1px solid var(--ch-line,#D8DCD9)}' +
    '.chm-i:last-child{border-bottom:0}' +
    '.chm-img{width:76px;height:76px;border:1px solid var(--ch-line,#D8DCD9);border-radius:8px;background:#F2F5F7;overflow:hidden;display:block}' +
    '.chm-img img{width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply;display:block}' +
    '.chm-t{font-size:14px;font-weight:600;line-height:1.35;color:var(--ch-ink,#0F1A24);text-decoration:none;display:block}' +
    '.chm-t:hover{color:var(--ch-blue,#136F99);text-decoration:underline}' +
    '.chm-v{font-size:12.5px;color:var(--ch-mute,#5A6570);margin-top:3px}' +
    '.chm-r{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:10px}' +
    '.chm-q{display:flex;border:1px solid var(--ch-line,#D8DCD9);border-radius:6px;overflow:hidden;height:34px}' +
    '.chm-q button{width:32px;border:0;background:#fff;cursor:pointer;font-size:17px;color:var(--ch-ink,#0F1A24)}' +
    '.chm-q button:disabled{opacity:.35;cursor:default}' +
    '.chm-q span{min-width:34px;display:grid;place-items:center;font-weight:700;font-size:14px;border-left:1px solid var(--ch-line,#D8DCD9);border-right:1px solid var(--ch-line,#D8DCD9)}' +
    '.chm-p{font-weight:800;font-size:15px;white-space:nowrap}' +
    '.chm-rm{border:0;background:none;padding:0;margin-top:8px;font-size:12.5px;color:var(--ch-mute,#5A6570);text-decoration:underline;cursor:pointer}' +
    '.chm-empty{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:24px;text-align:center;color:var(--ch-mute,#5A6570)}' +
    '.chm-f{border-top:1px solid var(--ch-line,#D8DCD9);padding:14px 18px calc(16px + env(safe-area-inset-bottom));display:flex;flex-direction:column;gap:10px;background:#fff}' +
    '.chm-sub{display:flex;justify-content:space-between;align-items:baseline;font-size:15px}' +
    '.chm-sub b{font-family:var(--ch-head,Archivo,sans-serif);font-size:21px;font-weight:800}' +
    '.chm-sub small{font-size:12px;color:var(--ch-mute,#5A6570);font-weight:400}' +
    '.chm .chm-btn{display:flex;align-items:center;justify-content:center;min-height:48px;border-radius:6px;font:700 15px/1 var(--ch-body,Inter,sans-serif);text-decoration:none;cursor:pointer;border:2px solid var(--ch-blue,#136F99);background:var(--ch-blue,#136F99);color:#fff!important;width:100%}' +
    '.chm .chm-btn:hover{background:var(--ch-blue-dk,#0E5677);border-color:var(--ch-blue-dk,#0E5677)}' +
    '.chm .chm-btn--2{background:var(--ch-ink,#0F1A24);border-color:var(--ch-ink,#0F1A24)}' +
    '.chm .chm-btn--2:hover{background:var(--ch-ink-2,#1C2833);border-color:var(--ch-ink-2,#1C2833)}' +
    '.chm-busy .chm-list,.chm-busy .chm-f{opacity:.55;pointer-events:none}' ;
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var wrap = document.createElement('div');
  wrap.className = 'chm-root';
  wrap.innerHTML = '<div class="chm-scrim" data-chm-close></div>' +
    '<aside class="chm" role="dialog" aria-modal="true" aria-labelledby="chm-title" aria-hidden="true">' +
    '<div class="chm-h"><b id="chm-title">Your basket</b><button type="button" class="chm-x" data-chm-close aria-label="Close basket">&times;</button></div>' +
    '<p class="chm-ok" data-chm-ok hidden><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>Added to your basket</p>' +
    '<div class="chm-body" data-chm-body style="flex:1;display:flex;flex-direction:column;min-height:0"></div>' +
    '</aside>';
  document.body.appendChild(wrap);
  var panel = wrap.querySelector('.chm'), body = wrap.querySelector('[data-chm-body]'), ok = wrap.querySelector('[data-chm-ok]'), title = wrap.querySelector('#chm-title');
  var lastFocus = null, skipUntil = 0;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '£' + (c / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function img(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function render(cart) {
    title.textContent = 'Your basket' + (cart.item_count ? ' (' + cart.item_count + ')' : '');
    if (!cart.item_count) {
      body.innerHTML = '<div class="chm-empty"><p>Your basket is empty.</p><a class="chm-btn chm-btn--2" href="' + root() + 'collections/all" style="max-width:260px">Continue shopping</a></div>';
      return;
    }
    var h = '<ul class="chm-list">';
    cart.items.forEach(function (it, i) {
      var v = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="chm-v">' + esc(it.variant_title) + '</div>' : '';
      h += '<li class="chm-i" data-line="' + (i + 1) + '">' +
        '<a class="chm-img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><a class="chm-t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + v +
        '<div class="chm-r"><div class="chm-q"><button type="button" data-chm-q="-1" aria-label="Decrease quantity"' + (it.quantity <= 1 ? ' disabled' : '') + '>&minus;</button><span aria-label="Quantity">' + it.quantity + '</span><button type="button" data-chm-q="1" aria-label="Increase quantity">+</button></div>' +
        '<span class="chm-p">' + money(it.final_line_price) + '</span></div>' +
        '<button type="button" class="chm-rm" data-chm-rm>Remove</button></div></li>';
    });
    h += '</ul><div class="chm-f"><div class="chm-sub"><span>Subtotal <small>incl. VAT</small></span><b>' + money(cart.total_price) + '</b></div>' +
      '<a class="chm-btn" href="' + root() + 'checkout">Checkout</a>' +
      '<a class="chm-btn chm-btn--2" href="' + root() + 'cart">View basket</a></div>';
    body.innerHTML = h;
  }

  function getCart() { return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function open(added) {
    ok.hidden = !added;
    lastFocus = document.activeElement;
    document.documentElement.classList.add('chm-open', 'chm-lock');
    panel.setAttribute('aria-hidden', 'false');
    setTimeout(function () { var x = panel.querySelector('.chm-x'); if (x) x.focus(); }, 60);
  }
  function close() {
    document.documentElement.classList.remove('chm-open', 'chm-lock');
    panel.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
  }

  function change(line, qty) {
    panel.classList.add('chm-busy');
    fetch(root() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart); ok.hidden = true;
        document.dispatchEvent(new CustomEvent('ch:cart-updated', { detail: { cart: cart, source: 'minicart' } }));
      })
      .catch(function () { getCart().then(render); })
      .then(function () { panel.classList.remove('chm-busy'); });
  }

  wrap.addEventListener('click', function (e) {
    if (e.target.closest('[data-chm-close]')) { close(); return; }
    var li = e.target.closest('.chm-i'); if (!li) return;
    var line = +li.getAttribute('data-line');
    var q = e.target.closest('[data-chm-q]');
    if (q) { var cur = +li.querySelector('.chm-q span').textContent; change(line, Math.max(0, cur + (+q.getAttribute('data-chm-q')))); return; }
    if (e.target.closest('[data-chm-rm]')) change(line, 0);
  });
  document.addEventListener('keydown', function (e) {
    if (!document.documentElement.classList.contains('chm-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href],button:not([disabled])'); if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });

  /* Buy it now goes straight to checkout - don't flash the drawer */
  document.addEventListener('click', function (e) { if (e.target.closest('.chp-now,[data-buy-now],[name="checkout"]')) skipUntil = Date.now() + 8000; }, true);

  function hideDup() {
    var t = document.querySelector('.chc-toast.is-on'); if (t) t.classList.remove('is-on');
    document.querySelectorAll('.chp-msg').forEach(function (m) { if (/added/i.test(m.textContent)) m.textContent = ''; });
  }

  document.addEventListener('ch:cart-updated', function (e) {
    var d = e.detail || {};
    if (d.source === 'minicart' || onCart || Date.now() < skipUntil) return;
    getCart().then(function (cart) { render(cart); open(true); });
    /* the drawer already says Added - clear the duplicate success notes (collection toast, product-page line) */
    [30, 450, 1200].forEach(function (ms) { setTimeout(hideDup, ms); });
  });

  window.chMiniCart = { open: function () { getCart().then(function (c) { render(c); open(false); }); }, close: close };
})();
